/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_LvInputs */

const cs_property_registry_lv = /** @type {(inputs: Property_Registry_LvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List vlastnictví (LV)`)
};

const en_property_registry_lv = /** @type {(inputs: Property_Registry_LvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title deed (LV)`)
};

/**
* | output |
* | --- |
* | "Title deed (LV)" |
*
* @param {Property_Registry_LvInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_lv = /** @type {((inputs?: Property_Registry_LvInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_LvInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_lv(inputs)
	return cs_property_registry_lv(inputs)
});